// @flow
import { type ActionType } from 'redux-actions';
import { requestSearchResults, receiveSearchResults } from './searchActions';
import { call, select, takeLatest, put } from 'redux-saga/effects';
import { selectToken } from 'ducks/SagaUtils';
import { addItemsTask } from 'ducks/coreDataSaga';

function* fetchResults(action: ActionType<typeof requestSearchResults>) {
  const { query, method } = action.payload;
  const token = yield select(selectToken);

  try {
    const response = yield call(method, token, query);
    let responseFormatted = response;
    if (response.ugc_results) {
      if (response.ugc_results.length === 0) {
        responseFormatted = response.ugc_results;
      } else {
        const pwr_observations = response.pwr_observation_codes;

        // Group results by ugc_id to merge syndicated products
        const grouped = {};
        response.ugc_results.forEach(ugc => {
          const key = ugc.ugc_id;
          if (!grouped[key]) {
            grouped[key] = { primary: ugc, associated_products: [] };
          }
          grouped[key].associated_products.push({
            page_id: ugc.page_id,
            product_name: ugc.product_name,
            product_image_url: ugc.product_image_url,
          });
        });

        responseFormatted = Object.values(grouped).map(({ primary: ugc, associated_products }) => {
          const {
            subject_id,
            ugc_id,
            page_id,
            product_image_url,
            created_date,
            author,
            rating,
            locale,
            device_id,
            source,
            custom_observation_codes,
            observations,
            editable,
            assignment_created_date,
            assignment_updated_date,
            assigned_to,
            assigned_by,
            publication_status,
          } = ugc;

          return {
            subject: {
              subject_id,
              subject_type: 'Product',
              name: ugc.product_name,
              page_id,
              product_image_url,
              associated_products: associated_products.length > 1 ? associated_products : [],
              merchant: {
                id: ugc.catalog_id,
                group_id: ugc.client_id,
              },
            },
            ugc: {
              ugc_id,
              subject_id,
              created_date,
              author,
              review_headline: ugc.headline,
              review_comments: ugc.primary_contents,
              rating,
              locale,
              device_id,
              ugctype: ugc.ugc_type,
              source,
              assignment_created_date,
              assignment_updated_date,
              assigned_to,
              assigned_by,
              editable,
              published: publication_status === 'APPROVED' ? true : false,
            },
            custom_observations: custom_observation_codes,
            existing_observations: observations,
            pwr_observations: pwr_observations,
          };
        });
      }
    }

    const itemsToPut = yield call(addItemsTask, {
      data: { items: responseFormatted },
    });

    const totalPages = response.total_pages != null ? response.total_pages : undefined;
    yield put.resolve(receiveSearchResults(itemsToPut.items, totalPages));
  } catch (err) {
    console.error(err);
    yield put(receiveSearchResults(err));
  }
}

export default function*(): Generator<*, *, *> {
  yield takeLatest(requestSearchResults, fetchResults);
}



// WEBPACK FOOTER //
// ./src/containers/search/searchSaga.js